import api from './config';

export const usersAPI = {
  // Obtener todos los usuarios
  getAll: async () => {
    const response = await api.get('/users');
    // Backend retorna { users: [...] }, extraemos el array
    return response.data.users || response.data || [];
  },

  // Obtener un usuario por ID
  getById: async (id) => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  // Crear nuevo usuario
  create: async (userData) => {
    const response = await api.post('/users', userData);
    return response.data;
  },

  // Actualizar usuario
  update: async (id, userData) => {
    const response = await api.put(`/users/${id}`, userData);
    return response.data;
  },

  // Cambiar estado (activo/inactivo)
  toggleStatus: async (id) => {
    const response = await api.patch(`/users/${id}/toggle-status`);
    return response.data;
  },

  // Resetear contraseña
  resetPassword: async (id, password) => {
    const response = await api.patch(`/users/${id}/reset-password`, { password });
    return response.data;
  },

  // Eliminar usuario
  delete: async (id) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },

  // Obtener estadísticas
  getStats: async () => {
    const response = await api.get('/users/stats/summary');
    return response.data;
  }
};
